import {
  IGenerateStrategyProps,
  IStrategy,
  Leg,
  ViewType,
} from "./../../../types";
import { analyzePositions } from "./../../analyzeProfits";

export const generateShortStrangle = (
  params: IGenerateStrategyProps,
  strategies: IStrategy[],
  atmCallIndex: number,
  atmPutIndex: number,
  expiryDuration: number
): IStrategy[] => {
  const { maxStrikes, lotSize, shortMargin } = params;
  for (let i = 1; i < maxStrikes; i++) {
    const callStrike = params.data.strikePrices[atmCallIndex + i];
    const putStrike = params.data.strikePrices[atmPutIndex - i];

    const callData = params.data.data.find(
      (val) =>
        val.expiryDates === params.expiryDate && val.strikePrice === Number(callStrike)
    );
    const putData = params.data.data.find(
      (val) =>
        val.expiryDates === params.expiryDate && val.strikePrice === Number(putStrike)
    );

    const legs: Leg[] = [
      {
        strikePrice: callStrike,
        price: callData?.CE?.lastPrice || 0,
        buy: false,
        call: true,
        quantity: -lotSize,
      },
      {
        strikePrice: putStrike,
        price: putData?.PE?.lastPrice || 0,
        buy: false,
        call: false,
        quantity: -lotSize,
      },
    ];

    const analysis = analyzePositions(legs);
    const marginRequired = 175000;
    const strategy: IStrategy = {
      legs: legs,
      riskRewardRatio: 1,
      maxProfit: analysis.maxProfit,
      maxLoss: Infinity,
      approxMargin: marginRequired,
      expiryDuration: expiryDuration,
      title: "Short Strangle " + callStrike + " - " + putStrike,
      maxLossROI: Infinity,
      maxProfitROI: (analysis.maxProfit * 100) / marginRequired,
      callBreakEven: analysis.breakEven.callBreakEven,
      putBreakEven: analysis.breakEven.putBreakEven,
      callBreakEvenPercentage:
        ((analysis.breakEven.callBreakEven - params.data.underlyingValue) /
          params.data.underlyingValue) *
        100,
      putBreakEvenPercentage:
        ((analysis.breakEven.putBreakEven - params.data.underlyingValue) /
          params.data.underlyingValue) *
        100,
      lotSize: params.lotSize,
      alert:
        "Short Strangle is a risky strategy. Max risk is much greater than max profit.",
      types: [
        ViewType["Moderately Negative"],
        ViewType["Moderately Positive"],
        ViewType.Neutral,
      ],
    };
    strategies.push(strategy);
  }
  return strategies;
};
